import { render, staticRenderFns } from "./hospitalListing.vue?vue&type=template&id=28825988&scoped=true"
import script from "./hospitalListing.vue?vue&type=script&lang=js"
export * from "./hospitalListing.vue?vue&type=script&lang=js"
import style0 from "./hospitalListing.vue?vue&type=style&index=0&id=28825988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28825988",
  null
  
)

export default component.exports